import {priority} from '@priority-software/priority-proto-api/lib';
import {PART_PARENT_DEFAULT_FIELDS, UNIT_FIELD_NAME} from './consts';
import {ColumnsData} from './types';

export const getSelectedColumnsData = (selectedColumns: string[], columns: ColumnsData[]) => {
    const data = [];

    selectedColumns.map(col => {
        const column = columns.find(c => c.columnName === col);
        if (column) {
            data.push(column);
        }
    });

    return data;
};

export const getEditingColumns = (
    columns: priority.netitems.form.IColumn[],
    inventoryColumns: priority.netitems.form.IColumn[]
) => {
    const filteredColumns = columns.filter(col => !PART_PARENT_DEFAULT_FIELDS.includes(col.Name));

    const lastId = Math.max(...filteredColumns.map(c => Number(c.ID)));

    //increase ID to prevent duplicate ids.
    const filteredInventoryColumns = inventoryColumns
        .filter(col => col.Name !== UNIT_FIELD_NAME)
        .map(col => ({...col, ID: Number(col.ID) + lastId}));

    return [...filteredColumns, ...filteredInventoryColumns];
};
